module.exports = __webpack_public_path__ + "img/bg-temple-default.d53e373b.png";